// General
import "@lottiefiles/lottie-player";
import { gsap, Power4 } from 'gsap'

import { ready } from './lib/utils/utils'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/controllers/expandable-controller';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import AccordionController from './lib/controllers/accordion-controller';
import AccordionItemController from './lib/controllers/accordion-item-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import DropdownController from './lib/controllers/dropdown';
import HeroController from './lib/controllers/hero.js';
import SlidingHeadlineController from './lib/controllers/sliding-headline.js';
import TeamSliderController from './lib/controllers/team-slider.js';
import ContactPersonController from './lib/controllers/contact-person-controller';
import MagazinShowcaseController from './lib/controllers/magazin-showcase.js';
import TeamMemberController from './lib/controllers/team-member.js';
import CompanyListController from './lib/controllers/company-list';
import TargetGroupsSliderController from './lib/controllers/target-groups-slider.js';
import ProfileSliderController from './lib/controllers/profile-slider.js';
import JobListingController from './lib/controllers/job-listing.js';
import ProfileListController from './lib/controllers/profile-list.js';
import InfographicAsSliderController from './lib/controllers/infographic-as-slider.js';
import InfographicOverlayController from './lib/controllers/infographic-overlay.js';
import SwiperController from './lib/controllers/swiper-controller';

// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { setupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.45
});

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('accordion', AccordionController);
  application.register('accordion-item', AccordionItemController);
  application.register('disruptor', DisruptorController);
  application.register('dropdown', DropdownController);
  application.register('hero', HeroController);
  application.register('sliding-headline', SlidingHeadlineController);
  application.register('team-slider', TeamSliderController);
  application.register('contact-person', ContactPersonController);
  application.register('magazin-showcase', MagazinShowcaseController);
  application.register('team-member', TeamMemberController);
  application.register('company-list', CompanyListController);
  application.register('target-groups-slider', TargetGroupsSliderController);
  application.register('profile-slider', ProfileSliderController);
  application.register('job-listing', JobListingController);
  application.register('profile-list', ProfileListController);
  application.register('infographic-as-slider', InfographicAsSliderController);
  application.register('infographic-overlay', InfographicOverlayController);
  application.register('swiper', SwiperController);

  // Setup functions
  SetupInViewDetection();
  SetupAnchorScrollTo(168);
  SetupLightbox();
  setupIsScrolledDetector();

  if (document.querySelector('.apply-now-link')) {
    document.querySelector('.apply-now-link').addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('#apply-now-form').submit();

    });
  }

});